import { render, staticRenderFns } from "./PixModal.vue?vue&type=template&id=a6fee4ea"
import script from "./PixModal.vue?vue&type=script&lang=js"
export * from "./PixModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports